import { createSlice } from "@reduxjs/toolkit";
import { TestCase } from "@src/pages/student/data.type";
import { parseInputToStringArray } from "@src/utils/CommonUtils";
import { toast } from "top-brains-ui";

interface InitialState {
  testCases: TestCase[];
  labels: string[];
  isHiddentestCaseAdded: boolean;
  moveToIndex?: number;
}

const initialState: InitialState = {
  testCases: [],
  labels: [],
  isHiddentestCaseAdded: false,
  moveToIndex: undefined,
};

const testCasesSlice = createSlice({
  name: "testCaseSlice",
  initialState: initialState,
  reducers: {
    setTestCases: (state, action) => {
      state.testCases = action?.payload?.testCases?.map(
        (testCase: TestCase) => ({
          ...testCase,
          disabled: false,
        })
      );
      state.labels = action.payload.labels;
    },
    addTestCase: (state, action) => {
      const newTestCase = state.testCases[action.payload.index || 0];
      state.testCases.push({
        ...newTestCase,
        disabled: false,
        canDelete: true,
      });
    },
    addHiddenTestCasetoRun: (state, action) => {
      if (state.testCases.filter(t => t?.canDelete).length < 10) {
        const newTestCase = {
          ...action.payload,
          input: parseInputToStringArray(action.payload.input),
        };
        state.testCases.push({
          ...newTestCase,
          disabled: false,
          canDelete: true,
        });
        state.isHiddentestCaseAdded = true;
      } else {
        toast.alert("You can't add more than 10 test cases.");
      }
    },
    moveToFailedTestCase: (state, action) => {
      state.isHiddentestCaseAdded = true;
      state.moveToIndex = action.payload;
    },
    deleteTestCase: (state, action) => {
      const index = action.payload.index;
      if (index >= 0 && index < state.testCases.length) {
        state.testCases.splice(index, 1);
      }
    },
    onInputChange: (state, { payload }) => {
      state.testCases[payload.selectedTestCase].input[payload.selectedInput] =
        payload.value;
    },
    onSqlSeedChange: (state, { payload }) => {
      state.testCases[payload.selectedTestCase].seedSql = payload.seedSql;
    },
    setIsHiddentestCaseAdded: (state, action) => {
      state.isHiddentestCaseAdded = action.payload;
    },
    setMoveToIndex: (state, action) => {
      state.moveToIndex = action.payload;
    },
  },
});
export const {
  addTestCase,
  onInputChange,
  onSqlSeedChange,
  setTestCases,
  deleteTestCase,
  addHiddenTestCasetoRun,
  setIsHiddentestCaseAdded,
  moveToFailedTestCase,
  setMoveToIndex,
} = testCasesSlice.actions;
export default testCasesSlice.reducer;
